<template>
    <div class="system_modal">
        <Transition name="fadeTop">
            <div @click="test" v-if="$GlobalStore.isShowUpdatePopup()" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.4); z-index: 10;"></div>
        </Transition>
        <div ref="frame" class="basic_frame" :style="{ top: $GlobalStore.isShowUpdatePopup() ? calcTop + '%' : '100%' }">
            <div style="font-weight: 700; font-size: 18px;">
                <img style="width: 100%" :src="require('@/assets/img/update_soccerhow.png')" alt="">
            </div>
            <div style="background-color: #fff; flex: 1; margin-top: -2px; text-align: center; padding: 0 20px; display: flex; flex-direction: column;">
                <div style="margin-top: 36px; font-size: 18px; font-weight: 700;">사커하우의 새로운 버전이 준비됐어요</div>
                <div style="margin-top: 20px; font-size: 14px; font-weight: 500; line-height: 20px; color: #606060;">사커하우 회원분들의 피드백을 토대로 대시보드와<br>주요 기능 등을 업데이트 했습니다.<br>더 나아진 편의성을 위해 앱을 업데이트 해주세요.</div>
                <div style="margin-top: 40px; background-color: var(--color-main); height: 50px; line-height: 50px; color: #fff; border-radius: 6px;" @click="goUserAppDownload">지금 바로 업데이트 하기</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'updatepopup',
    data() {
        return {
            calcTop: 0,
        }
    },
    methods : {
        goUserAppDownload(){
            let url = '';
            const device = this.$cookies.get('device');
            if (device === 'android') {
                url = 'market://details?id=com.ubiplus.custom.obyungear_user';
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                url = 'itms-apps://itunes.apple.com/app/6443870201';
            }
            this.$Util.showBrowser(url);
        }
    },
    mounted() {
        const screenHeight = screen.height
        if (screenHeight <= 770) {
            this.calcTop = 44
        } else {
            this.calcTop = 56
        }
    }

}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.system_modal {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    transition: all 0.5s;
    overflow-y: hidden;
}

.basic_frame {
    display: flex;
    flex-direction: column;
    background-color: transparent;
    border-top-right-radius: 24px;
    border-top-left-radius: 24px;
    /* height: 368px; */
    position: absolute;
    /* top: 100%; */
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0);
    transition: 0.5s all;
    z-index: 9999;
    /* text-align: center; */
    font-weight: 500;
    box-shadow: 0px 1px 10px 0px #210F0333;
    width: 100%;
    overflow: hidden;
}

.fadeTop-enter-active,
.fadeTop-leave-active {
    transition: all .3s;
}

.fadeTop-enter,
.fadeTop-leave-to {
    top: 56%;
    opacity: 0;
}
</style>